<script>
    import AnimationsMixin from "../../../author/pagesbuilder/mixins/AnimationsMixin";
    import FocusMixin from "../../../author/pagesbuilder/mixins/FocusMixin";

    export default {
        name: "InputElement",
        mixins: [
            FocusMixin,
            AnimationsMixin
        ],
        data() {
            return {
                elementType: 'input'
            }
        },
        methods: {
            getPlaceholder() {
                return this.myNode.getAttribute('placeholder');
            },
            setPlaceholder (placeholder) {
                this.myNode.setAttribute('placeholder', placeholder);
            }
        }
    }
</script>
